import { sanitize } from '../utils/sanitizeText'
import { getURL, baseInteraction, sendEvent } from './utils'

export const TagPushCarousel = {
    interactionProductButton: (type, url, text = 'none', cardName = 'none') => {
        let event = {
            event: 'interaction',
            element_type: `box:${sanitize(type)}:click`,
            element_content: `none:${sanitize(text)}:${sanitize(cardName)}`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionProductLink: (type, url, text = 'none', cardName = 'none') => {
        let event = {
            event: 'interaction',
            element_type: `select:${sanitize(type)}:click`,
            element_content: `none:${sanitize(text)}:${sanitize(cardName)}`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:home',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionProductClose: (url, cardName = 'none') => {
        let event = {
            event: 'interaction',
            element_type: `box:button:click`,
            element_content: `none:fechar:${sanitize(cardName)}`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:simulacao',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionProductDropdown: (url, text = 'none', cardName = 'none') => {
        let event = {
            event: 'interaction',
            element_type: `select:dropdown:click`,
            element_content: `none:${sanitize(text)}:${sanitize(cardName)}`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: 'loja-virtual:simulacao',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    interactionProductField: (field, error, url, cardName = 'none') => {
        let event = {
            event: 'interaction',
            element_type: `box:${sanitize(field)}-field:filled`,
            element_content: `none:os-melhores-beneficios:${sanitize(cardName)}`,
            section_app: `loja-virtual:${getURL(url)}`,
            screen_name: error
                ? `loja-virtual:simulacao:${sanitize(error)}`
                : 'loja-virtual:simulacao',
            screen_type: 'pagina',
            ...baseInteraction()
        }
        sendEvent(event)
    },
    addToCart: (product) => {
        let item = {}
        if (product) {
            item = {
                item_name: sanitize(product.name),
                item_id: product.code,
                price: product.value,
                item_brand: 'alelo',
                item_category: 'cartoes',
                quantity: product.quantity
            }
        }

        let event = {
            event: 'add_to_cart',
            ecommerce: {
                items: [item]
            }
        }
        sendEvent(event)
    },
    viewItem: (products = []) => {
        let items = []
        if (products.length > 0) {
            items = products.map((product) => ({
                item_name: sanitize(product.name),
                item_id: product.code,
                item_category2: 'ecommerce'
            }))
        }
        let event = {
            event: 'view_item',
            ecommerce: { items }
        }
        sendEvent(event)
    },
    selectItem: (product) => {
        let item = {}
        if (product) {
            item = {
                item_name: sanitize(product.name),
                item_id: product.code
            }
        }

        let event = {
            event: 'select_item',
            ecommerce: {
                items: [item]
            }
        }
        sendEvent(event)
    }
}
